export default "__VITE_ASSET__ca834dfd__"